import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { apiPost, useAuth } from '../contexts/AuthContext';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Label } from '../components/ui/label';
import AuthLayout from '../components/AuthLayout';

/** Step 1 of password recovery: e-mail a one-hour confirm link to the partner. */
export default function ForgotPasswordPage() {
  const { formatApiErrorDetail } = useAuth();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await apiPost('/auth/forgot-password', { email });
      setSent(data.message);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Forgot your password?" subtitle="We'll e-mail you a link to get a new one" testId="forgot-password-page">
      {sent ? (
        <div role="status" className="p-4 bg-brand/10 border border-brand/30 rounded-lg text-ink text-sm" data-testid="forgot-sent">
          {sent} Check your inbox (and spam folder). The link expires in 1 hour.
        </div>
      ) : (
        <>
          {error && <div role="alert" className="mb-4 p-3 bg-danger/10 border border-danger/30 rounded-lg text-danger text-sm">{error}</div>}
          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="space-y-2">
              <Label htmlFor="forgot-email" className="text-ink font-medium">Email</Label>
              <Input id="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com"
                required data-testid="forgot-email-input" className="h-11 bg-surface border-contrast/[0.12] shadow-sm" />
            </div>
            <Button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full h-11 bg-brand hover:bg-brand-soft text-white font-medium rounded-lg">
              {loading ? 'Sending…' : 'Send reset link'}
            </Button>
          </form>
        </>
      )}
      <p className="mt-6 text-center text-sm text-ink-2">
        <Link to="/login" className="text-brand hover:text-brand-soft font-medium underline-offset-4 hover:underline">Back to sign in</Link>
      </p>
    </AuthLayout>
  );
}
